export const RESIDENCY_STATUS_KEY_VALUES = {
  Current: 'Current',
  Future: 'Future',
  FormerActive: 'FormerActive',
  FormerClosed: 'FormerClosed'
};
export const RESIDENCY_ADDRESS_STATUS = {
  pending: 'Pending',
  approved: 'Approved',
  declined: 'Declined'
};